import axios, { AxiosRequestConfig , InternalAxiosRequestConfig} from 'axios';
import { BASE } from './constants';

const sessionItem:any = window.sessionStorage.getItem('user-key')
const {user_key, tenant_id} = sessionItem ? JSON.parse(sessionItem): {user_key:null, tenant_id: BASE.company.tenant}


const apiUser = axios.create({
  baseURL: 'https://users.bepass.app',
  headers: {
    'x-api-key': 'KW_sNizaSyDu_QNDPXcix4EAIXE9N9Ux_oH8g3q4dft3',
    'x-tenant-id': tenant_id,
    'x-api-flow': 'onboarding',
  }
});

export { apiUser };